import { render, staticRenderFns } from "./ProductUsagesList.vue?vue&type=template&id=170d3f53&scoped=true"
import script from "./ProductUsagesList.vue?vue&type=script&lang=js"
export * from "./ProductUsagesList.vue?vue&type=script&lang=js"
import style0 from "./ProductUsagesList.vue?vue&type=style&index=0&id=170d3f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170d3f53",
  null
  
)

export default component.exports